<template>
  <div>
    <static-about-us />
    <static-footer :pageObj="aboutUsPage"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import StaticFooter from '@/components/Footer/StaticFooter'
import StaticAboutUs from '@/components/StaticPages/StaticAboutUs'

export default {
  name: 'AboutUs',
  components: {
    StaticAboutUs,
    StaticFooter,
  },
  computed: {
    ...mapGetters(['_T_DB', 'all_static_pages']),
    aboutUsPage() {
      if (this.all_static_pages) {
        return this.all_static_pages.find(
          page => page.type === 'regular' && page.slug === 'about'
        )
      }
      return {}
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
